import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { TransaccionService } from 'src/app/dashboard/services/transaccion.service';
import { CognitoService } from 'src/app/auth/services/cognito.service';
import Swal from 'sweetalert2';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { RejectTransactionDTO } from 'src/app/dashboard/interfaces/reject-transaction.dto';
import { WalletVesAdminService } from 'src/app/dashboard/services/wallet-ves-admin.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-reject-transaction-withdraw-modal',
  templateUrl: './reject-transaction-withdraw-modal.component.html',
  styleUrls: ['./reject-transaction-withdraw-modal.component.sass']
})
export class RejectTransactionWithdrawModalComponent {
  datosForm: FormGroup | undefined;
  motivosRechazo = ['DNI incorrecto', 'Cuenta incorrecta'];
  private transaction: undefined | any;
  constructor(
    private auth: CognitoService,
    private readonly transactionService: TransaccionService,
    private readonly walletVesAdminService: WalletVesAdminService,
    private fb: FormBuilder,
    private spinner: SpinnerService, public dialogRef: MatDialogRef<RejectTransactionWithdrawModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any ){
     this.transaction = data;
     this.initForm();
  }

  initForm(){
    this.datosForm = this.fb.group({
      motivo: new FormControl('', [Validators.required]),
      comentario: new FormControl('', [Validators.maxLength(100)]),
    });
  }

  /**
   * C1 (22/10/2026): un FIAT_VES_CLP solo se rechaza por Nest con su `cardexId`.
   * Sin él caía a la lambda, que abonaba los VES como CLP en `balances` y además
   * devolvía los VES. Falta cuando la lista no pudo leer los retiros VES
   * pendientes (`cardexIdNoDisponible`) o el retiro no vino en esa lista.
   */
  get faltaCardexVes(): boolean {
    return this.transaction?.tipoTransaccion === 'FIAT_VES_CLP' && !this.transaction?.cardexId;
  }

  /**
   * B6 (22/10/2026): el motivo de la falta cambia el mensaje. Con la marca de la
   * lista (`cardexIdNoDisponible`) falló el GET de pendientes; sin ella el GET
   * anduvo y el retiro no estaba: ya no está pendiente.
   */
  get mensajeFaltaCardexVes(): string {
    return this.transaction?.cardexIdNoDisponible
      ? 'No se pudo obtener el retiro VES. Recarga e intenta de nuevo.'
      : 'Este retiro VES ya no está pendiente (puede que ya se haya aprobado o rechazado). Recarga la lista.';
  }

  async rejectTransaction(){
    if(this.datosForm?.invalid)return;
    if (this.faltaCardexVes) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: this.mensajeFaltaCardexVes,
        showCancelButton: false,
        showDenyButton: false,
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#1e5a3f',
      });
      this.dialogRef.close(true);
      return;
    }
    const spinnerRef = this.spinner.start();
    try{
      if (this.transaction.tipoTransaccion === 'FIAT_VES_CLP' && this.transaction.cardexId) {
        const reason = this.datosForm?.get('motivo')?.value + (this.datosForm?.get('comentario')?.value ? ': ' + this.datosForm?.get('comentario')?.value : '');
        await firstValueFrom(this.walletVesAdminService.rejectRetiroVes(this.transaction.cardexId, reason));
      } else {
        const datos: RejectTransactionDTO = {...this.datosForm?.value, transactionID: this.transaction.id };
        await this.transactionService.rejectTransaction(datos);
      }
      Swal.fire({
        icon: 'success',
        title: 'Transacción rechazada',
        text: 'la transacción se ha rechazado exitosamente',
        showCancelButton: false,
        showDenyButton: false,
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#1e5a3f',

      });
      this.dialogRef.close(true);
    }catch(error: any){
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.error.mensaje,
        showCancelButton: false,
        showDenyButton: false,
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#1e5a3f',

      });
      this.dialogRef.close(true);
    }

    this.spinner.stop(spinnerRef);
  }

  close(){
    this.dialogRef.close();
  }

  }

